import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  MmButtonModule,
  MmChipModule,
  MmFlexLayoutModule,
  MmIconModule,
  MmPaginatorModule,
} from '@metromarkets/components';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { TranslateModule } from '@ngx-translate/core';

import { CatalogRoutingModule } from './catalog-routing.module';
import { PageLoadingModule } from '~shared/components/page-loading/page-loading.module';
import { ImageHeaderModule } from '~shared/components/image-header/image-header.module';
import { NewsletterSubscriptionModule } from '~shared/modules/newsletter-subscription/newsletter-subscription.module';
import { CategoryCarouselModule } from '~shared/modules/category-carousel/category-carousel.module';
import { CatalogLoadingModule } from '~shared/modules/catalog';

import { catalogReducers, CustomPlpEffects, ProductsEffects, SortEffects } from './store';

// New imports from shared folder
import {
  CatalogActionsModule,
  CatalogToolbarModule,
  CategoryChildrenModule,
  CatalogBodyModule,
} from '~shared/modules/catalog/catalog-products-list/modules';

import {
  CatalogComponent,
  CatalogFactoryComponent,
  CatalogProductsListComponent,
  CategoryPlpComponent,
  CategoryPlpLoadingComponent,
  CustomPlpComponent,
  RecommendedProductsComponent,
} from './components';

import { CATALOG_FEATURE_NAME } from './store/feature-name';
import { FiltersModule } from '../filters/filters.module';
import { KebabCaseModule } from '~shared/pipes';

import { MmSelectModule } from '~shared/modules/mm-select/mm-select.module';

import { DefaultImageModule } from '~shared/directives/default-image/default-image.module';
import { BasePageModule } from '~shared/modules/base-page/base-page.module';
import { MmExpansionModule } from '~shared/modules/mm-expansion/mm-expansion.module';

import { BreadcrumbsModule } from '~shared/components/breadcrumbs/breadcrumbs.module';

import { StickyModule } from '~shared/directives/sticky/sticky.module';
import { ExtendedModule, FlexModule } from '@angular/flex-layout';
import { LazyLoadImageModule } from '~shared/directives/lazyload/lazy-load-image.module';
import { SeoModule } from '~shared/modules/seo/seo.module';
import { ProductsGridModule } from '~shared/modules/products-grid/products-grid.module';
import { IsVisibleModule } from '~shared/directives/is-visible/is-visible.module';
import { GenericModule } from '~app/modules/generic/generic.module';
import { TooltipModule } from '~shared/modules/tooltip/tooltip.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { StoryblokModule } from '~app/modules/storyblok/storyblok.module';
import { VatDisclaimerPLPs } from '~shared/components/vat-disclaimer-plps';
import { AppProductCarouselModule } from '~shared/components/app-product-carousel/app-product-carousel.module';
import { CurrencyService } from '~shared/services/currency.service';
import { MatIconModule } from '@angular/material/icon';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokEditableModule } from '~app/modules/storyblok/directives/storyblok-editable/storyblok-editable.module';
import { FilterFacetsCarouselModule } from '~shared/modules/catalog';
import { CategoryFacetsCarouselModule } from '~shared/components/category-facets-carousel/category-facets.module';
import { StoryblokSeoModule } from '~shared/modules/storyblok-seo/storyblok-seo.module';

@NgModule({
  declarations: [
    CatalogFactoryComponent,
    CatalogComponent,
    CatalogProductsListComponent,
    RecommendedProductsComponent,
    CustomPlpComponent,
    CategoryPlpComponent,
    CategoryPlpLoadingComponent,
  ],
  imports: [
    CommonModule,
    CatalogRoutingModule,
    StoreModule.forFeature(CATALOG_FEATURE_NAME, catalogReducers),
    EffectsModule.forFeature([ProductsEffects, SortEffects, CustomPlpEffects]),
    MmButtonModule,
    MatProgressSpinnerModule,
    MmFlexLayoutModule,
    MmIconModule,
    MmChipModule,
    SeoModule,
    StoryblokSeoModule,
    FiltersModule,
    MmSelectModule,
    MmPaginatorModule,
    TranslateModule,
    MmButtonModule,
    KebabCaseModule,
    QaLocatorsModule,
    DefaultImageModule,
    BasePageModule,
    MmExpansionModule,
    BreadcrumbsModule,
    StickyModule,
    FlexModule,
    LazyLoadImageModule,
    ProductsGridModule,
    IsVisibleModule,
    PageLoadingModule,
    GenericModule,
    ImageHeaderModule,
    TooltipModule,
    FilterFacetsCarouselModule,
    NgxSkeletonLoaderModule,
    StoryblokModule,
    VatDisclaimerPLPs,
    AppProductCarouselModule,
    NewsletterSubscriptionModule,
    MatIconModule,
    CarouselModule,
    ExtendedModule,
    CategoryFacetsCarouselModule,
    DynamicModule,
    StoryblokEditableModule,
    CategoryCarouselModule,
    CatalogLoadingModule,
    CatalogActionsModule,
    CatalogToolbarModule,
    CategoryChildrenModule,
    CatalogBodyModule,
  ],
  providers: [CurrencyService],
})
export class CatalogModule {}
